import React from 'react';
import { Grid, TextField, Autocomplete } from '@mui/material';

const PatientInfoSection = ({ formData, handleChange, errors, onBlur }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          name='uhid_no'
          label='UHID No.'
          inputProps={{ readOnly: true }}
          variant='outlined'
          fullWidth
          value={formData.uhid_no}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label={<span>Surgery Date & Time <span style={{ color: '#ff0000' }}>*</span></span>}
          name="entry_date_time"
          type="datetime-local"
          value={formData.entry_date_time}
          onChange={handleChange}
          onBlur={onBlur}
          fullWidth
          error={!!errors.entry_date_time}
          helperText={errors.entry_date_time || ' '}
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: new Date().toISOString().slice(0, 16) }}
        />
      </Grid>
    </Grid>
  );
};

export default PatientInfoSection;
